import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import styles from "../ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Google BigQuery Training</h3>
          <p>
            Tribalism is a web analytics, cloud infrastructure and digital
            marketing company with office space in Sydney and Melbourne
            Australia. We have delivered multiple in-house Google Bigquery
            Training sessions across Australia and overseas. We are recognised
            locally as leaders in the space with a growing reputation
            internationally as well.
            <br />
            <br />
            We’d love to assist you and your team get to grips with BigQuery and
            the rest of the Google Cloud stack as well.
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>What to expect:</h3>
          <p>
            Sessions vary as to your requirements, but some of the areas covered
            may include:
          </p>
          <ul>
            <li>
              Intro to Bigquery – the basics: what it is, where it lives, how to
              access it, using the public data samples available
            </li>
            <li>
              SQL Refresher – Bigquery uses two types of syntax, Legacy SQL and
              Standard SQL. We’ll go over the differences and show the most
              often used functions in BigQuery
            </li>
            <li>
              Specific Use cases: want to join up some external tables in
              BigQuery for analysis – we can help you.
            </li>
            <li>Interacting with the rest of the Google stack with BigQuery</li>
            <li>User access control through IAM and the Cloud Console</li>
            <li>
              More Advanced features: Views v Tables, User Defined Functions,
              Dealing with Array data types
            </li>
            <li>
              Importing Data to Bigquery: User Interface, Google Cloud Storage
            </li>
            <li>
              Accessing Bigquery programmatically: through Google Scripts, the
              Command Interface, Google App Engine
            </li>
          </ul>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/sections/services/google-bigquery-training/1.jpg"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Google BigQuery Interface</i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Flexible to your plans:</h3>
          <p>
            It is easy for us to come to you, wherever you are across Australia,
            New Zealand or the Asia Pacific region.
            <br />
            <br />
            Training agendas will be agreed with you in advance. If you like we
            can design the agenda completely for you, or if you have specific
            areas you’d like to cover we can tailor the agenda to your areas of
            focus.
            <br />
            <br />
            Or rates are very competitive and will be agreed with you in
            advance. If you are interested please don’t hesitate to drop us a
            line so we can get your Google Analytics implementation in top
            shape.{" "}
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Our guarantee to you</h3>

          <ol>
            <li>
              Quality: We will deliver quality work. It's the first thing all of
              our staff are trained in - “completed” is not good enough - it
              needs to be done well!
            </li>
            <li>
              Communication: We cannot guarantee that everything will be perfect
              the first time. Most things aren't. But what we can guarantee is
              easy communication to anyone in our business to discuss any issues
              and fix any problems asap.
            </li>
            <li>
              Innovative: We are anti-silo. Like life - you can't just focus on
              one thing to fix your problems. We are well versed on every facet
              of this field - and with that comes innovative approaches to your
              business issues.
            </li>
          </ol>

          <br />
          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
